import { render } from "./Troubleshooting.vue?vue&type=template&id=2f144a61"
import script from "./Troubleshooting.vue?vue&type=script&lang=ts"
export * from "./Troubleshooting.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./Troubleshooting.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script